import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { Icon } from './Icon';
import { CenterForm, Flexbox, FlexboxCenter } from './Layout';
import { PopupOverlay } from './PopupOverlay';

const DialogForm = styled.div`
  margin: 5rem 3rem;
  position: relative;
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  color: ${Colors.white};
`;

const FormContent = styled(CenterForm)`
  padding-bottom: 6rem;
`;

const FormText = styled.p`
  flex: 1;
  margin: 0 0 0 2rem;

  font-size: 2.125rem;
  line-height: 1.21;

  a {
    text-decoration: underline;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  margin-bottom: 2rem;

  button:hover {
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }
`;

const AlertIconWrapper = styled(FlexboxCenter)`
  width: 6rem;
  height: 6rem;
  border-radius: 100%;
  background-color: ${Colors.secondary};
  padding: 1rem;
`;

interface Props {
  open?: boolean;
  hideCloseIcon?: boolean;
  onClose?: () => void;
  renderContent: () => React.ReactNode;
}
export const AlertPopup: FC<Props> = ({ open = true, hideCloseIcon = false, onClose, renderContent }) => {
  return (
    <PopupOverlay {...{ open }}>
      <DialogForm>
        {
          !hideCloseIcon &&
          <IconWrapper>
            <button onClick={() => onClose && onClose()}>
              <Icon icon={"state-error"} size={64} />
            </button>
          </IconWrapper>
        }
        <FormContent>
          <Flexbox>
            <AlertIconWrapper>
              <Icon icon={"info-circle"} size={64} />
            </AlertIconWrapper>
            <FormText>
              {
                renderContent && renderContent()
              }
            </FormText>
          </Flexbox>
        </FormContent>
      </DialogForm>
    </PopupOverlay>
  )
}
